import { DeviceAccessIcon, Logout01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Head, router } from "@inertiajs/react";
import Dashboard from "@/components/dashboard";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import type HomeUser from "@/types/serializers/HomeUser";
import type SessionsSession from "@/types/serializers/SessionsSession";

interface Props {
	user: HomeUser;
	sessions: SessionsSession[];
}

export default function Index({ user, sessions }: Props) {
	const handleLogout = (sessionId: number) => {
		router.delete(`/sessions/${sessionId}`);
	};

	const formatDate = (dateString: string) => {
		return new Date(dateString).toLocaleString("cs-CZ", {
			day: "numeric",
			month: "long",
			year: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		});
	};

	return (
		<>
			<Head title="Aktivní relace" />
			<Dashboard user={user}>
				<div className="flex flex-1 flex-col gap-6 p-4 lg:p-6">
					<div className="flex items-center gap-3">
						<div className="flex size-10 items-center justify-center rounded-lg bg-primary/10">
							<HugeiconsIcon
								icon={DeviceAccessIcon}
								strokeWidth={2}
								className="size-5 text-primary"
							/>
						</div>
						<div>
							<h2 className="font-semibold text-2xl">Aktivní relace</h2>
							<p className="text-muted-foreground text-sm">
								Spravujte svá přihlášení na různých zařízeních
							</p>
						</div>
					</div>

					<Card>
						<CardHeader>
							<CardTitle>Přihlášená zařízení</CardTitle>
							<CardDescription>
								Zde vidíte všechna zařízení, na kterých jste přihlášeni.
							</CardDescription>
						</CardHeader>
						<CardContent className="space-y-4">
							{sessions.map((session) => (
								<div
									key={session.id}
									className="flex items-center justify-between gap-4 rounded-lg border p-4"
								>
									<div className="flex flex-col gap-1">
										<div className="flex items-center gap-2">
											<span className="font-medium text-sm">
												{session.user_agent || "Neznámé zařízení"}
											</span>
											{session.is_current && (
												<Badge variant="secondary">Aktuální</Badge>
											)}
										</div>
										<div className="text-muted-foreground text-xs">
											<span>IP: {session.ip_address || "Neznámá"}</span>
											<span className="mx-2">·</span>
											<span>Přihlášeno: {formatDate(session.created_at)}</span>
										</div>
									</div>
									<Button
										variant="outline"
										size="sm"
										onClick={() => handleLogout(session.id)}
									>
										<HugeiconsIcon
											icon={Logout01Icon}
											strokeWidth={2}
											className="size-4"
										/>
										Odhlásit
									</Button>
								</div>
							))}

							{sessions.length === 0 && (
								<p className="py-4 text-center text-muted-foreground text-sm">
									Žádné aktivní relace
								</p>
							)}
						</CardContent>
					</Card>
				</div>
			</Dashboard>
		</>
	);
}
